/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalidurl1Inputs */

const en_invalidurl1 = /** @type {(inputs: Invalidurl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid URL`)
};

const de_invalidurl1 = /** @type {(inputs: Invalidurl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültige URL`)
};

/**
* | output |
* | --- |
* | "Invalid URL" |
*
* @param {Invalidurl1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invalidurl1 = /** @type {((inputs?: Invalidurl1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalidurl1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalidurl1(inputs)
	return de_invalidurl1(inputs)
});
export { invalidurl1 as "invalidUrl" }